import React, {Suspense} from 'react';
import {connect} from "react-redux";

import {AuthLayout, Header} from './LazyLoadedPages';

import TaskForm from "#app/pages/Relations/Tasks/form/TaskForm";
import {setTaskForm, setTaskModalVisible, setTaskType} from "#app/redux/actions/task";

// @TODO уточнить типы
interface CabinetLayoutProps {
    modalVisible: boolean;
    setTaskModalVisible: (visible: boolean) => void;
    taskForm: any;
    taskType: any;
    setTaskType: (type: any) => void;
    setTaskForm: (form: any) => void;
    auth: any;
}

const CabinetLayout: React.FC<CabinetLayoutProps> = ({
    modalVisible,
    setTaskModalVisible,
    taskForm,
    taskType,
    setTaskType,
    setTaskForm,
    auth
}) => (
    <Suspense>
        <Header/>
        <AuthLayout/>
        <TaskForm
            setModalVisible={setTaskModalVisible}
            modalVisible={modalVisible}
            form={taskForm}
            taskType={taskType}
            setTaskType={setTaskType}
            setForm={setTaskForm}
            callback={() => {}}
            auth={auth}
        />
    </Suspense>
);

const enhance = connect(
    (state: any) => ({
        modalVisible: state.task.modalVisible,
        taskForm: state.task.form,
        taskType: state.task.type,
        auth: state.auth,
    }),
    {setTaskModalVisible, setTaskForm, setTaskType}
);

export default enhance(CabinetLayout);











